import script from "./NavbarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarComponent.vue?vue&type=script&setup=true&lang=js"

import "./NavbarComponent.vue?vue&type=style&index=0&id=448ca426&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-448ca426"]])

export default __exports__